<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import moment from "moment";
import {commonService} from "@/services/common";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {inventoryService} from "@/services/authservice/inventory";
import UtilsMixin from "@/mixins/utils";
import {brandService} from "@/services/authservice/brand";

export default {
  page: {
    title: "Danh sách đơn nhập hàng từ nhãn",
    meta: [{name: "description", content: appConfig.description}],
  },
  mixins: [UtilsMixin],
  components: {Layout, PageHeader, TableLoading, TableEmpty, DatePicker, Multiselect},
  data() {
    return {
      listData: [],
      listRegion: [],
      listBrand: [],
      title: "Danh sách đơn nhập hàng từ nhãn",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Danh sách đơn nhập hàng từ nhãn",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        {key: "index", label: "#"},
        {key: "gr_id", label: "Mã đơn"},
        {key: "gr_time", label: "Thời gian nhập"},
        {key: "export_from_name", label: "Kho nhập"},
        {key: "created_by", label: "Người khởi tạo"},
        {key: "created_at", label: "Ngày khởi tạo"},
      ],
      isBusy: false,
      me: {},
      listStatus: [
        {id: "PENDING", name: "Chờ xác nhận"},
        {id: "COMPLETED", name: "Hoàn thành"},
        {id: "CANCELED", name: "Đã huỷ"},
      ],
      searchData: {
        id: "",
        brand: "",
        status: {id: "COMPLETED", name: "Hoàn thành"},
        date: [],
      }
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getStartEndMonth();
    this.getInitData();
  },
  computed: {
    rows() {
      return this.listData.length;
    },
  },
  mounted() {
    this.totalRows = this.listData.length;
  },
  methods: {

    onFiltered() {
      this.totalRows = this.listData.length;
      this.currentPage = 1;
    },

    getStartEndMonth() {
      let date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
      // dateTimestamp
      this.searchData.date = [firstDay, lastDay];
      this.searchData.dateTimestamp = [moment(firstDay).valueOf(), moment(lastDay).unix() + 86399000]
    },

    async getInitData() {
      this.isBusy = true;
      const responseRegion = await commonService.getListRegion();
      if (responseRegion.data.error) {
        this.listRegion = [];
      } else {
        this.listRegion = responseRegion.data.data;
      }
      const resBrand = await brandService.getList();
      if (resBrand.data.error) {
        this.listBrand = [];
      } else {
        this.listBrand = resBrand.data.data;
      }
      await this.getListOrder({
        status: this.searchData.status ? this.searchData.status.id : "",
        from_timestamp: (this.searchData.date.length > 0 && this.searchData.date[0]) ? this.searchData.date[0].getTime() : "",
        to_timestamp: (this.searchData.date.length > 0 && this.searchData.date[1]) ? this.searchData.date[1].getTime() + 86399000 : "",
      });
      this.isBusy = false;
    },

    async getListOrder(param) {
      const fparam = {...param, results_per_page: 1000, gr_type: 'NMH'};
      const response = await inventoryService.getListGoodsReceipt(fparam);
      if (response.data.error) {
        this.listData = {};
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: response.data.error.message,
        });
      } else {
        this.listData = response.data.data;
      }
    },

    renderRegion(id) {
      const find = this.listRegion.filter(e => e.id === id);
      return find[0].region_name;
    },

    async onSearch() {
      const param = {
        gr_id: this.searchData.id ? this.searchData.id : "",
        export_from_uid: this.searchData.brand ? this.searchData.brand.id : "",
        status: this.searchData.status ? this.searchData.status.id : "",
        from_timestamp: (this.searchData.date.length > 0 && this.searchData.date[0]) ? this.searchData.date[0].getTime() : "",
        to_timestamp: (this.searchData.date.length > 0 && this.searchData.date[1]) ? this.searchData.date[1].getTime() + 86399000 : "",
      }
      this.isBusy = true;
      await this.getListOrder(param);
      this.isBusy = false;
    },

    async onResetSearch() {
      this.currentPage = 1;
      this.searchData = {
        id: "",
        brand: "",
        status: {id: "COMPLETED", name: "Hoàn thành"},
        date: [],
      }
      this.isBusy = true;
      await this.getListOrder({
        status: this.searchData.status ? this.searchData.status.id : "",
        from_timestamp: (this.searchData.date.length > 0 && this.searchData.date[0]) ? this.searchData.date[0].getTime() : "",
        to_timestamp: (this.searchData.date.length > 0 && this.searchData.date[1]) ? this.searchData.date[1].getTime() + 86399000 : "",
      });
      this.isBusy = false;
    }

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-lg-12">
            <div class="d-flex search-container">
              <div class="form-group mb-0 mr-2">
                <b-input
                    @keydown.enter.native="onSearch"
                    type="text"
                    class="form-control"
                    placeholder="Mã phiếu"
                    v-model="searchData.id"
                />
              </div>
              <multiselect
                  id="customer"
                  v-model="searchData.brand"
                  :options="listBrand"
                  track-by="id"
                  label="trademark_name"
                  :searchable="false"
                  placeholder="Chọn nhãn hàng"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="mr-2"
              ></multiselect>
              <multiselect
                  id="status"
                  v-model="searchData.status"
                  :options="listStatus"
                  track-by="id"
                  label="name"
                  :searchable="false"
                  placeholder="Chọn trạng thái"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="mr-2"
              ></multiselect>
              <date-picker
                  v-model="searchData.date"
                  :first-day-of-week="1"
                  lang="en"
                  range
                  format="DD/MM/YYYY"
                  placeholder="Chọn khoảng thời gian"
              ></date-picker>
              <div class="d-flex ml-2 align-items-start">
                <button type="button" class="btn btn-primary" @click="onSearch">Lọc</button>
                <button type="button" class="ml-2 btn btn-secondary" @click="onResetSearch">
                  <i class="bx bx-revision"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  show-empty
                  :items="listData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  :busy="isBusy"
                  table-class="scroll-table"
              >
                <template v-slot:table-busy>
                  <TableLoading/>
                </template>
                <template v-slot:empty>
                  <TableEmpty/>
                </template>
                <template v-slot:cell(index)="row">
                  {{ ((currentPage - 1) * perPage) + row.index + 1 }}
                </template>
                <template v-slot:cell(gr_id)="row">
                  <router-link :to="{ name: 'InventoryImportDetail', params: { id: row.item.id }}">
                    {{ row.item.gr_id }}
                  </router-link>
                </template>
                <template v-slot:cell(gr_time)="row">
                  {{ formatDateUnix(row.item.gr_time) }}
                </template>
                <template v-slot:cell(require_time)="row">
                  {{ formatDateUnix(row.item.require_time) }}
                </template>
                <template v-slot:cell(created_at)="row">
                  {{ formatDateUnix(row.item.created_at) }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="mt-3 float-right">
                  <b-pagination
                      class="mb-0"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>